import axios from "axios";

const storageService = axios.create({
    baseURL: process.env.VUE_APP_SUPPORT + "/storage",
    timeout: 30000,
    withCredentials: true
});
storageService.defaults.headers['Product'] = 'vsp';

storageService.interceptors.request.use(res => {
    res.headers["token"] = JSON.parse(localStorage.getItem("USER")) ? JSON.parse(localStorage.getItem("USER")).token : '';
    return res;
})

storageService.interceptors.response.use(
    response => {
        if (response.data.errCode === 1) {
            window.$vm.$Message.error(response.data.errMsg);
            return Promise.reject(response.data);
        }

        return response.data;
    },

    error => {
        window.$vm.$Message.error(error.response.data.errMsg);
        return Promise.reject(error)
    }
);

export default {
    ApplySecurityToken(dir, type) {
        return storageService.post("/applySecurityToken", {
            type: type || "public",
            dir: dir || "dq-storage"
        });
    },
    // 读取文件流
    readFileStream(url) {
        storageService.defaults.headers['Content-type'] = 'application/json';
        return storageService.post(`/readFileStream`, url);
    },

};